import {gql} from '@apollo/client';

import {doQuerySafe} from 'graphql-client/ApolloWrappers';

import {RefetchStudyTags, RefetchStudyTagsVariables} from './__generated/RefetchStudyTags';

export const STUDIES_TAG_QUERY = gql`
  query RefetchStudyTags($studyIds: [StrictString!]!) @skipAudit @engComponent(name: STUDIES) {
    studies(ids: $studyIds) {
      ... on StudyNode {
        id
        tagsJson
      }
    }
  }
`;

export default async function refetchStudyTags(studyIds: Array<string>): Promise<void> {
  await doQuerySafe<RefetchStudyTags, RefetchStudyTagsVariables>(
    {query: STUDIES_TAG_QUERY},
    {variables: {studyIds}, fetchPolicy: 'network-only'}
  );
}
